import { createApp } from 'vue'
import App from './App.vue'
import './style.scss'

createApp(App).mount('#app')
